// /src/contexts/AuthContext.js
import React, { createContext, useState, useEffect } from "react";
import { login, logout, refreshToken, verifyAuth } from "../api/auth/authService";
import { getAccessToken } from "../utils/storage";


export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
 
  useEffect(() => {
    const verify = async () => {
      const token = getAccessToken();
      if (token) {
        try {
          
          await verifyAuth();
          setIsAuthenticated(true);
        } catch {
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };
    verify();
  }, []);

 const handleLogin = async (email, password) => {
    try {
      console.log("AuthContext: Attempting login for:", email);
      await login(email, password);
      setIsAuthenticated(true);
      console.log("AuthContext: Login successful, navigating to /dashboard");
      
      return true;
    } catch (error) {
      console.error("AuthContext: Login failed:", error.message);
      setIsAuthenticated(false);
      throw error;
    }
  };

  const handleRefreshToken = async () => {
    try {
      await refreshToken();
      setIsAuthenticated(true);
    } catch (error) {
      setIsAuthenticated(false);
      throw error;
    }
  };

  const handleLogout = async () => {
    try {
      await logout();
      setIsAuthenticated(false);
      
      return { message: "Logout successful" };
    } catch (error) {
      setIsAuthenticated(false);
     
      throw error;
    }
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        isLoading,
        login: handleLogin,
        logout: handleLogout,
        refreshToken: handleRefreshToken,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};